/* Copyright (C) NewFoundry 2021 All rights reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */
"use strict";

var _classCallCheck = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _inherits = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

var _createSuper = require("/Users/ryanlevin/NewFoundry/Brightsmith/brightsmith-wp/src/plugins/brightsmith-wp-react-app/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createSuper");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var axios_1 = __importDefault(require("axios"));

var dayjs_1 = __importDefault(require("dayjs"));

var utc_1 = __importDefault(require("dayjs/plugin/utc"));

var base_1 = __importDefault(require("./base"));

var session_1 = require("../session");

dayjs_1.default.extend(utc_1.default);
var HEADERS = {
  headers: {
    'Content-Type': 'text/plain'
  }
};

var AWSAnalyticsHandler = /*#__PURE__*/function (_base_1$default) {
  _inherits(AWSAnalyticsHandler, _base_1$default);

  var _super = _createSuper(AWSAnalyticsHandler);

  function AWSAnalyticsHandler(apiRoot) {
    var _this;

    var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, AWSAnalyticsHandler);

    _this = _super.call(this);
    _this.apiRoot = apiRoot;
    _this.opts = opts;
    return _this;
  }

  _createClass(AWSAnalyticsHandler, [{
    key: "getPayload",
    value: function getPayload(userEvent) {
      var _a;

      var session = session_1.getCurrentSession();
      var payload = {
        session: session,
        userEvent: userEvent
      };

      if ((_a = this.opts) === null || _a === void 0 ? void 0 : _a.ttl) {
        var ttl = this.getTTL(this.opts.ttl);

        if (ttl) {
          payload.ttl = "".concat(ttl);
        }
      }

      return payload;
    }
  }, {
    key: "getTTL",
    value: function getTTL(ttl) {
      try {
        var now = dayjs_1.default.utc();
        var lastSunday = now.day(0);
        var eod = lastSunday.hour(23).minute(0).second(0);
        var expiresOn = eod.unix() + parseInt(ttl);
        return expiresOn;
      } catch (e) {
        console.warn('Error assigning TTL to analytics event', e);
      }
    }
  }, {
    key: "track",
    value: function track(userEvent) {
      var payload = this.getPayload(userEvent);
      var url = "".concat(this.apiRoot, "analytics/event");
      axios_1.default.post(url, payload, HEADERS).then(function (resp) {
        console.log(resp);
      }).catch(function (error) {
        return console.error(error);
      });
      console.log('BRIGHTSMITH_ANALYTICS:TRACK', userEvent, session_1.getCurrentSession());
    }
  }, {
    key: "pageView",
    value: function pageView(pageUrl) {
      var userEvent = {
        action: 'Viewed a Page',
        category: 'Page View',
        label: pageUrl
      };
      var payload = this.getPayload(userEvent);
      var url = "".concat(this.apiRoot, "analytics/event");
      axios_1.default.post(url, payload, HEADERS).then(function (resp) {
        console.log(resp);
      }).catch(function (error) {
        return console.error(error);
      });
      console.log('BRIGHTSMITH_ANALYTICS:PAGEVIEW', pageUrl, session_1.getCurrentSession());
    }
  }]);

  return AWSAnalyticsHandler;
}(base_1.default);

exports.default = AWSAnalyticsHandler;